import Vue from 'vue';
import selectNotice from '../../components/notice/select-notice.vue';
import sendNotice from '../../components/notice/send-notice.vue';
import successNotice from '../../components/notice/success-notice.vue';
export default Vue.extend({
    data: function () {
        return {
            active: 0,
            templateCode: '',
            uploadKey: '',
            isSubmit: false,
            options: [],
            showMsg: '',
            successData: {},
        };
    },
    components: {
        selectNotice: selectNotice,
        sendNotice: sendNotice,
        successNotice: successNotice,
    },
    created: function () {
        this.getMessageModel();
    },
    methods: {
        stepMain: function (flag) {
            flag === 0 &&
                ((this.active = 0), this.$router.push({ name: 'noticeAssistant' }));
        },
        toSureSend: function (data) {
            this.active = data.active;
            this.templateCode = data.templateCode;
            this.uploadKey = data.uploadKey;
        },
        showMsgPhone: function (value) {
            this.showMsg = value;
        },
        getMessageModel: function () {
            var _this = this;
            this.$request({
                method: 'post',
                url: '/proxy/api/msg/template/list',
            }).then(function (res) {
                if (!res)
                    return;
                if (res && !res.errorCode) {
                    _this.options = res.data;
                }
            });
        },
        showSuccess: function (data) {
            this.successData = data;
            this.isSubmit = true;
        },
        returnSelectNotice: function () {
            this.isSubmit = false;
            this.active = 0;
        },
    },
});
